import { create } from 'zustand'

const useRouter = create((set) => ({
  base: '/',
  setBase: (base) => set({base}),
}));

export default useRouter;